import { useEffect, useState, useRef } from 'react';

import { isBrowser } from '@utils/environmentCheck';

export const useElementScroll = elementRef => {
  const previousScrollPos = useRef(isBrowser ? window.scrollY : 0);
  const [isElementScrolled, setIsElementScrolled] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!isBrowser || !elementRef.current) return null;

      const { y, height } = elementRef.current.getBoundingClientRect();

      setIsElementScrolled(window.innerHeight > y + height);
      setIsScrollingDown(window.scrollY > previousScrollPos.current);

      previousScrollPos.current = window.scrollY;

      return null;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [elementRef]);

  return { isElementScrolled, isScrollingDown };
};
